export const BASE_HOST = process.env.GATSBY_APP_HOST;

export const EDITOR_HOST = `${BASE_HOST}/create-roar`;
export const PRICING = `${BASE_HOST}/plans`;
export const SIGN_IN = `${BASE_HOST}/sign-in`;
export const SIGN_UP = `${BASE_HOST}/sign-up`;
export const FREE_TRIAL = `${BASE_HOST}/plans?freeTrial=true`;
export const SIGN_OUT = `${BASE_HOST}/sign-out`;
export const PROFILE = `${BASE_HOST}/profile`;
export const DASHBOARD = `${BASE_HOST}/dashboard`;
export const WL_PRICING = 'https://wl.theroar.io/';

// Social links
export const TWITTER = 'https://twitter.com/roaraugmented';
export const FB = 'https://www.facebook.com/ROARaugmented/';
export const YOUTUBE =
  'https://www.youtube.com/channel/UCVmfOX80BAGaOFOmBmGSc2g';
export const LINKEDIN =
  'https://www.linkedin.com/company/roar-augmented-reality/';
export const PERFORMLIVE = 'https://performlive.live';

// Mobile App
export const APP_STORE =
  'https://apps.apple.com/us/app/roar-augmented-reality-app/id1045561660';
export const GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.roar.scanner';

// Inner links
export const HOME_PAGE = '/';
export const INDUSTRIES = '#use-cases';
export const PRODUCTS_PAGE = '/products';
export const GALLERY_PAGE = '/roar-gallery';
export const EDITOR_PAGE = '/editor';
export const SCANNER_PAGE = '/scanner';
export const WHITE_LABEL_PAGE = '/white-label';
export const BLOG_PAGE = '/media-and-blogs';
export const SUPPORT_PAGE = '/support';
export const CONTACT_US_PAGE = '/contact-us';
export const PRIVACY_PAGE = '/privacy';
export const TERMS_PAGE = '/terms';
export const REFUND_PAGE = '/refund';
export const USER_GUIDE_PAGE = '/getting-started';
